export const LetterType = {
  Standard: 100,
  Compact: 200, //Kompakt
  Large: 400, //Großbrief
  PZU: 500, //Postzustellungsurkunde
  Maxi: 600,
  MaxiPlus: 650,
  Package: 700
}
